import { type IQuestion, type IQuestionBase } from "../../../../Common/models";
import { asQuestionsMap } from "features/Library/Common/QuestionsForm/Questions/QuestionsBuilder/QuestionProvider";
import { AssessmentTextQuestion } from "../AssessmentFields";
import { AssessmentQuestionType, type MultipleChoiceQuestion, type SingleChoiceQuestion } from "../../../types/state";

/* istanbul ignore next */
export const QuestionsMap = asQuestionsMap({
  [AssessmentQuestionType.MultipleChoiceTextQuestion]: {
    Component: AssessmentTextQuestion,
    castQuestion: (Question: IQuestionBase) => Question as IQuestion<SingleChoiceQuestion>,
  },
  [AssessmentQuestionType.SingleChoiceTextQuestion]: {
    Component: AssessmentTextQuestion,
    castQuestion: (Question: IQuestionBase) => Question as IQuestion<MultipleChoiceQuestion>,
  },
});
